"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isArrayLikeObject = _interopRequireDefault(require("lodash/isArrayLikeObject"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _react = require("react");

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ssrWindow = require("ssr-window");

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var Portal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Portal, _PureComponent);

  function Portal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Portal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Portal).call(this, props));
    var className = props.className,
        appendTo = props.appendTo;
    _this._EL = _ssrWindow.document.createElement('div');
    _this._ROOT = (0, _isString.default)(appendTo) ? _dom.default.el(appendTo) : appendTo;

    if ((0, _isArrayLikeObject.default)(_this._ROOT)) {
      _this._ROOT = _this._ROOT[0];
    }

    if (className) {
      _dom.default.addClass(_this._EL, className);
    }

    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._ROOT.appendChild(this._EL);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._ROOT.removeChild(this._EL);
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _reactDom.createPortal)(this.props.children, this._EL);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Portal;
}(_react.PureComponent);

exports.default = Portal;
(0, _defineProperty2.default)(Portal, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The content to insert into the portal. */
  children: _propTypes.default.node.isRequired,

  /** The element or selector of the element for where the portal should be appended in the DOM tree. */
  appendTo: _propTypes.default.oneOfType([_propTypes.default.object, // Should be PropTypes.instanceOf(Element) but SSR won't support that
  _propTypes.default.string])
});
(0, _defineProperty2.default)(Portal, "defaultProps", {
  appendTo: _ssrWindow.document.body
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Portal, "Portal", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Portal/Portal.jsx");
  leaveModule(module);
})();

;